import type { ComponentProps } from 'react';

import { SvgIcon } from './SvgIcon.tsx';

type Props = Omit<ComponentProps<typeof SvgIcon>, 'viewBox'>;

export const CardsMissing = (props: Props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M14.2227 1C15.1945 1.00024 15.9998 1.80546 16 2.77734V13.4443C16 14.4442 15.1947 15.2224 14.2227 15.2227H7.11133C6.11133 15.2227 5.33301 14.4443 5.33301 13.4443V2.77734C5.33324 1.80532 6.11148 1 7.11133 1H14.2227ZM3.33301 2.33301C3.69412 2.33301 4 2.63889 4 3V13.2227C3.99977 13.6113 3.69398 13.8887 3.33301 13.8887C2.94443 13.8885 2.6672 13.6112 2.66699 13.2227V3C2.66699 2.63899 2.94429 2.33318 3.33301 2.33301ZM9.78809 11.2598V12.8438H11.5283V11.2598H9.78809ZM0.666992 3.66699C1.02785 3.66718 1.33282 3.97215 1.33301 4.33301V11.8887C1.33301 12.2774 1.02796 12.5555 0.666992 12.5557C0.278103 12.5557 0 12.2776 0 11.8887V4.33301C0.000166836 3.97204 0.27822 3.66699 0.666992 3.66699ZM10.6523 4C8.76851 4 8.00014 4.64788 8 6.09961V7.05957H9.5V5.27246H11.8164V7.41992L9.9082 8.27246V10.3721H11.4082V8.91992L13.3164 8.06836V6.09961C13.3163 4.64797 12.5359 4.00008 10.6523 4Z"
      fill="currentColor"
    />
  </SvgIcon>
);
